import React, {Component} from 'react';
import {connect} from 'react-redux';
import classNames from "classnames";
import {Flipped} from "react-flip-toolkit";
import {bindActionCreators} from "redux";

import {emptyVehicle} from '../actions'
import {onElementAppear, onElementExit} from '../utils'

class VehicleInformationBox extends Component {
    render() {
        const containerClasses = classNames(
            'search_box',
            'information_box',
            'vehicle_information_box',
        );
        return (
            <Flipped
                flipId={`vehicle_information_box`}
                onDelayedAppear={onElementAppear}
                onExit={onElementExit}
                key={`vehicle_information_box`}
                delay={3}
                translate
                opacity>
                <div className={containerClasses}>
                    <div className={"exh4"}>Véhicule selectionné</div>
                    <div>
                        <img
                            src={ "https://media.partauto.fr/brand/" + this.props.vehicle.brand.name.toLowerCase().replace(/\s/g, '_') + ".webp"}/>

                        <strong> {this.props.vehicle.brand.name} </strong>
                        {this.props.vehicle.model.name}<br/>{this.props.vehicle.type.name} ({this.props.vehicle.model.start_date} - {this.props.vehicle.model.end_date})
                        {this.props.vehicle.licencePlate ? <i> Imm.&nbsp;:&nbsp;{this.props.vehicle.licencePlate}</i> : null}
                    </div>
                    <button onClick={() => this.props.emptyVehicle()}>Changer de véhicule</button>
                </div>
            </Flipped>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        vehicle: state.vehicle
    }
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        emptyVehicle
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(VehicleInformationBox)